<template>
  <div>

    <h4 v-if="title">{{title}}</h4>
    <el-form
      :model="localData"
      :ref="formRef"
      :rules="rules"
      :inline="inlineForm"
      :label-position="labels"
      :label-width="labels !== 'top' ? maxLabel + 'px' : ''">

      <el-row :gutter="8">
        <span v-for="item in this.form.fields" :key="item.prop">

          <el-col :span="spans">

          <span v-if="isNumberType(item)">
            <float-input v-if="isDecimalType(item)"
              :id="item.id"
              :label="item.label"
              :required="item.required ? item.required : false"
              :prop="item.prop"
              :min="item.min ? item.min : 0"
              :max="item.max ? item.max : Number.MAX_SAFE_INTEGER"
              v-model="localData[item.prop]"
              @change="updated"
              :disabled="dis"
               />

           <number-input v-else
              :label="item.label"
              :required="item.required ? item.required : false"
              :prop="item.prop"
              v-model="localData[item.prop]"
              @change="updated"
              :disabled="dis"
               />

          </span>

          <date-input v-if="isDateType(item)"
            :label="item.label"
            :required="item.required ? item.required : false"
            :prop="item.prop"
            :format="item.format ? item.format : null"
            v-model="localData[item.prop]"
            :disabled="dis"
          />

          <select-input v-if="isArrayType(item)"
            :label="item.label"
            :required="item.required ? item.required : false"
            :prop="item.prop"
            :list="item.list"
            v-model="localData[item.prop]"
            :disabled="dis"
          />

          <text-input v-if="isTextType(item)"
            :label="item.label"
            :required="item.required ? item.required : false"
            :prop="item.prop"
            v-model="localData[item.prop]"
            :disabled="dis"
          />

          <html-input v-if="isHtmlType(item)"
            :label="item.label"
            :required="item.required ? item.required : false"
            :prop="item.prop"
            v-model="localData[item.prop]"
            :disabled="dis"
          />

          </el-col>
        </span>
      </el-row>

      <el-row>
        <el-col :span="23" align="right">

            <el-button v-if="!dis" type="success" icon="fa fa-check" @click="localSave" :disabled="dis">Save</el-button>

        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>

/**
Example:
fields: [
  {type: Array, prop: 'status', list: ['Pending', 'Rejected', 'Condtional', 'Approved'], label: 'Status', required: true},
  {type: Date, prop: 'approvedDate', label: 'Approval Date', format: 'dd MMM yyyy'},
  {type: Number, prop: 'deposit', decimal: 0, label: 'Security Deposit'},
  {type: String, prop: 'remarks', html: true, label: 'Remarks'}
]

*/

import GoogleMap from './GoogleMap'

export default {
  name: 'auto-form',

  components: {
    GoogleMap
  },

  props: {
    formRef: {
      type: String,
      default: 'autoForm'
    },

    form: {
      type: Object,
      required: true
    },

    value: {
      required: true
    },

    save: {
      type: Function,
      required: true
    },

    inline: {
      type: Boolean,
      default: false
    },

    labelPos: {
      type: String,
      default: 'top'
    },

    title: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    overrideSpan: {
      type: Number,
      default: null
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },

    check (item) {
      if (item && item.type) {
        return true
      } else {
        this.$message({message: 'Field item problem [' + !item ? 'Empty item' : 'no type prop for: ' + (item && item.label ? item.label : 'No label') + ']', type: 'warning'})
        return false
      }

    },

    isArrayType (item) {
      if (this.check(item) && item.type === Array &&
       item.hasOwnProperty('list')) {
        return true
      } else {
        return false
      }
    },

    isDecimalType (item) {
      if (this.check(item) && item.type === Number &&
       item.hasOwnProperty('decimal') && item.decimal > 0) {
        return true
      } else {
        return false
      }
    },

    isNumberType (item) {
      if (this.check(item) && item.type === Number) {
        return true
      } else {
        return false
      }
    },

    isDateType (item) {
      if (this.check(item) && item.type === Date) {
        return true
      } else {
        return false
      }
    },

    isTextType (item) {
      if (this.check(item) && item.type === String &&
      ((item.hasOwnProperty('html') && !item.html) || (!item.hasOwnProperty('html')))) {
        return true
      } else {
        return false
      }
    },

    isHtmlType (item) {
      if (this.check(item) && item.type === String && item.hasOwnProperty('html') && item.html) {
        return true
      } else {
        return false
      }
    },

    checkProps (prop, type) {

      if (this.form.hasOwnProperty(prop)) {

        if (typeof this.form[prop] === type) {
          return this.form[prop]
        } else {
          this.$message({message: 'Prop: "' + prop + '"  must be [' + type + ']', type: 'error'})
        }

      }

      return null
    },

    localSave () {

      if (this.save) {
        this.save(this.localData)
      }
    }

  },

  data () {
    return {
      inlineForm: this.inline,
      cols: 1,
      spans: 24,
      dis: this.disabled,
      localData: this.value,
      maxLabel: 96,
      fontRatio: 32,
      labels: this.labelPos,
      rules: {}
    }
  },

  created () {
    this.inlineForm = this.checkProps('inline', 'boolean')
    this.dis = !this.disabled ? this.checkProps('disabled', 'boolean') : this.disabled
    this.cols = this.checkProps('columns', 'number')
    this.spans = this.overrideSpan ? this.overrideSpan : Math.round((24 / (this.cols ? this.cols - 1 : 1)), 0)


    if (this.form && this.form.hasOwnProperty('fields')) {

      for (var i = 0; i < this.form.fields.length; i++) {
        this.form.fields[i].id = this.getType(this.form.fields[i].type) + i

        // Build the rules for validation
        if (this.form.fields[i].required) {
          let item = this.form.fields[i]
          let lbl = item.label
          let req = item.required ? item.required : false
          let prp = item.prop
          let msg = 'Required: Please input [' + lbl + ']'

          this.rules[prp] = [{required: req, message: msg, trigger: (this.isTextType(item) ? 'blur' : 'change')}]
        }

        this.maxLabel = Math.max(this.maxLabel, this.form.fields[i].label.length)
      }

      this.maxLabel += this.fontRatio
    } else {
      this.$message({message: 'Empty or Invalid Form (no fields) passed to AutoForm', type: 'error'})
    }
  }


}

</script>
